import {Button, Row} from 'reactstrap';
import NumberInput from '../NumberInput';
import React, {Component, Fragment} from 'react';
import PropTypes from 'prop-types';
import styles from './PackageBlock.scss';
import capitalize from 'lodash/capitalize';
import LoadingIndicator from '../LoadingIndicator';

export default class PackageBlock extends Component {

  static propTypes = {
    primaryColor: PropTypes.string.isRequired,
    packageType: PropTypes.string.isRequired,
    bestFor: PropTypes.string,
    onInputQuantityChange: PropTypes.func,
    isLoadingPrice: PropTypes.bool,
    actionBtn: PropTypes.func,
    eventQuantity: PropTypes.number,
    price: PropTypes.number,
    discountValue: PropTypes.number,
    discountDescr: PropTypes.object,
    primaryButtonStyle: PropTypes.object,
    secondaryButtonStyle: PropTypes.object,
    themeLightestBgColor: PropTypes.string,
    estimatedPrice: PropTypes.bool
  };
  
  renderFree = () => {
    return (
      <Fragment>
        <div className="package-type">
        Free Listing
        </div>
        <div className="upgrade-later" style={{ color: this.props.primaryColor }}>
          <span>Upgrade <br/>Later</span>
        </div>
        <Button className="btn-themed" onClick={() => this.props.actionBtn()}
          style={this.props.secondaryButtonStyle}>
          Continue for free
        </Button>
      </Fragment>
    );
  }

  isFreePackage(){
    return this.props.packageType === 'free';
  }

  render() {
    const { packageType, primaryColor, themeLightestBgColor, primaryButtonStyle } = this.props;
    const pricePerEvent = Math.ceil(this.props.price / this.props.eventQuantity);

    return (
      <div className={styles.packageBlock}>
        { this.isFreePackage() && this.renderFree() }
        { !this.isFreePackage() &&
          <Fragment>
            <div className="package-type">
              {packageType}
            </div>
            <div className="package-best-for">
            Best for <span className="bolder">{this.props.bestFor}</span> events.
            </div>
            <div className="package-pricing">
              <span className="amount-per-event" style={{ color: primaryColor}}>
                {this.props.currency}
                {this.props.isLoadingPrice ? <LoadingIndicator/> : pricePerEvent}</span>
              per event
              {this.props.estimatedPrice && <small> (estimated)</small>}
              <div className="total">
                {capitalize(packageType)} Total:
                &nbsp;
                <span className="amount-total">
                  {this.props.currency}{this.props.isLoadingPrice ? <LoadingIndicator/> : this.props.price}
                  {this.props.packageType == 'subscription' && '/month'}
                </span>
              </div>
            </div>
            <Button className="btn-themed" style={primaryButtonStyle}
              onClick={() => this.props.actionBtn()}>Buy Now</Button>
            <div className="credits" style={{backgroundColor: themeLightestBgColor}}>
              <Row className="number-input">
                <div className="mx-auto">
                  <NumberInput
                    value={this.props.eventQuantity}
                    onChange={this.props.onInputQuantityChange()}
                    min={this.props.packageType === 'subscription' ? 4 : 1}
                    disabled={false}
                  />
                  <span className="help-txt">
                    Event / Credit
                  </span>
                </div>
              </Row>
              <div className="discount" style={{ color: primaryColor }}>
                <div className="value">
                  {this.props.discountValue}%
                </div>
                <div className="descr">
                  {this.props.discountDescr}
                </div>
              </div>
            </div>
          </Fragment>
        }
      </div>
    );
  }
}



// WEBPACK FOOTER //
// app/client/bundles/EventSubmission/components/snapsell/PackageBlock.jsx